import {BaseLS} from './BaseLS';
import {IEnum} from '../../../@types/enum';

const STORAGE_KEY = 'language';

export class Language extends BaseLS<IEnum> {
  constructor() {
    super(STORAGE_KEY);
  }
}
